import React, { useEffect, useState } from 'react'
import { ReactP5Wrapper } from "react-p5-wrapper";
import './Drawings.css'

const canvawt = 600 * 4
const canvaht = 600

const min_x = 150
const max_x = (canvawt - min_x)

const min_y = 150 * 4
const max_y = (canvaht - min_y)

const alldoodles_ = [
    [
        {
            "color": "#1f2faf",
            "points": [{ "x": 152, "y": 71.5 }, { "x": 141, "y": 65.5 }]
        },
        {
            "color": "#1f2faf",
            "points": [{ "x": 83, "y": 127.5 }, { "x": 75, "y": 120.5 }, { "x": 72, "y": 120.5 }]
        }
    ],

    [
        {
            "color": "#1f2faf",
            "points": [{ "x": 152, "y": 71.5 }, { "x": 141, "y": 65.5 }]
        },
        {
            "color": "#1f2faf",
            "points": [{ "x": 83, "y": 127.5 }, { "x": 75, "y": 120.5 }, { "x": 72, "y": 120.5 }]
        }
    ]
]

const nodegapconstant = 2

let t = 0;
const speed = 0.01;
const scale = 0.2;

const repulsion = 50000;
const centering = 0.1;
const friction = 0.5;

const Drawingcanva = (props) => {
    const { flowerdata } = props
    // help me animate the currentflower path in Gbdrawings_drawingcanvainner container : 

    const FlowerAnimation = ({ currentflower }) => {
        const paths = currentflower.map((flower, index) => {
            const d = flower.points.map((p, i) =>
                `${i === 0 ? "M" : "L"} ${p.x} ${p.y}`
            ).join(" ");

            return (
                <path
                    key={index}
                    d={d}
                    stroke={flower.color}
                    strokeWidth={2}
                    fill="none"
                    className="flower-path"
                />
            );
        });

        return (
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 300 300"
                className="flower-svg"
            >
                {paths}
            </svg>
        );
    };

    const { backgroundColor } = props

    return <div className='Gbdrawings_drawingcanvaroot'>
        <div className='Gbdrawings_drawingcanva' style={{ backgroundColor: backgroundColor }}>
            <div className='Gbdrawings_drawingcanvainner'>
                <FlowerAnimation currentflower={flowerdata[1]} />
            </div>
            <div className='Gbdrawings_colorrow'>
                <div className='Gbdrawings_colorcircle' />
            </div>
        </div>
        <div className='Gbdrawings_subtitle' style={{ marginTop: 40 }}>
            Pick a theme, whether it’s flowers, hearts, or something totally random. Your guests draw, and we turn all their doodles into one big art piece.
        </div>
    </div>
}

const Drawalldoodles = (props) => {
    const { flowerdata } = props

    // --- NEW: Define Constants for Timing and Simulation (Assumed/Required) ---
    const SIMULATION_DURATION = 5; // The target duration in seconds
    const frameRate = 60;          // Standard P5.js frame rate
    let stopFrame;                 // Variable to hold the frame count when the simulation must stop

    // NOTE: Variables like scale, centering, etc. are assumed to be defined 
    // or passed via props. Defining defaults here for the code to run:
    // const scale = 1.0; 
    // const centering = 0.005; 
    // const repulsion = 1500;
    // const friction = 0.9;
    // const speed = 0.05;
    let t = 0; // Initialization of 't'

    function sketch(p) {
        let nodes = [];

        // ----------- Convert one doodle into an IMAGE (Unchanged) -----------
        function doodleToImage(doodle) {
            let allXs = [];
            let allYs = [];

            doodle.forEach(seg => {
                seg.points.forEach(pt => {
                    allXs.push(pt.x);
                    allYs.push(pt.y);
                });
            });

            const minX = Math.min(...allXs);
            const maxX = Math.max(...allXs);
            const minY = Math.min(...allYs);
            const maxY = Math.max(...allYs);

            const w = (maxX - minX) * scale;
            const h = (maxY - minY) * scale;

            // create image buffer
            const g = p.createGraphics(w, h);

            g.strokeWeight(2);
            g.noFill();

            doodle.forEach(({ color, points }) => {
                g.stroke(color);
                g.beginShape();
                points.forEach(pt => {
                    let sx = (pt.x - minX) * scale;
                    let sy = (pt.y - minY) * scale;
                    g.vertex(sx, sy);
                });
                g.endShape();
            });

            return { img: g, w, h };
        }

        p.setup = () => {
            p.createCanvas(canvawt, canvaht);
            p.frameRate(frameRate); // Set frame rate for reliable timing

            // --- NEW: Calculate the target frame count for stopping ---
            stopFrame = p.frameCount + (SIMULATION_DURATION * frameRate);
            // --- END NEW ---

            // Convert all doodles into images ONCE
            // nodes = [...flowerdata, ...flowerdata].map((d) => {
            nodes = flowerdata.map((d) => {
                const { img, w, h } = doodleToImage(d);
                return {
                    img,
                    w,
                    h,
                    x: p.random(min_x, max_x),
                    y: p.random(min_y, max_y),
                    vx: 0,
                    vy: 0,
                };
            });
        };

        // ---- FORCE SIMULATION (Unchanged) ----
        function simulateForces() {
            for (let i = 0; i < nodes.length; i++) {
                let n1 = nodes[i];

                // Pull to center
                n1.vx += (p.width / 2 - n1.x) * centering;
                n1.vy += (p.height / 2 - n1.y) * centering;

                // Repel from others
                for (let j = i + 1; j < nodes.length; j++) {
                    let n2 = nodes[j];

                    let dx = n1.x - n2.x;
                    let dy = n1.y - n2.y;
                    let dist = Math.sqrt((dx * dx) + (dy * dy)) || 1;

                    const f = repulsion / (dist * dist);
                    const fx = f * (dx / dist);
                    const fy = f * (dy / dist);

                    
                    n1.vx += fx * nodegapconstant;
                    n1.vy += fy * nodegapconstant;
                    n2.vx -= fx * nodegapconstant;
                    n2.vy -= fy * nodegapconstant;
                }
            }

            nodes.forEach(n => {
                n.vx *= friction;
                n.vy *= friction;
                n.x += n.vx;
                n.y += n.vy;
            });
        }

        // ---- SUBTLE MOVEMENT (Unchanged) ----
        function subtleMovement() {
            nodes.forEach((n, i) => {
                const wobble = 0.5;
                n.x += Math.sin(p.frameCount * 0.01 + i) * wobble;
                n.y += Math.cos(p.frameCount * 0.013 + i) * wobble;
            });
        }

        p.draw = () => {
            p.background(props.backgroundColor);

            // --- NEW: Conditional Execution based on Time ---
            if (p.frameCount < stopFrame) {
                // RUNNING PHASE: Execute all movement and transition logic
                t = Math.min(1, t + speed);
                simulateForces();
                subtleMovement();
            } else {
                // STOPPED PHASE: Lock 't' and skip all movement functions
                t = 1;
                // The position (x, y) of the nodes is now fixed.
            }
            // --- END NEW ---

            nodes.forEach((node) => {
                p.image(node.img, node.x - node.w / 2, node.y - node.h / 2);
            });
        };
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: 950, height: 950, width: '100vw' }}>
            <div style={{ width: canvawt, height: canvaht, display: 'flex', placeSelf: 'center' }}>
                <div style={{ transform: "scale(0.8)", display: 'flex', placeContent: 'center' }}>
                    <ReactP5Wrapper sketch={sketch} />
                </div>
            </div>
            <div style={{ position: 'relative', top: -250, display: 'flex', width: '100vw', placeContent: 'center' }}>
                <Drawingcanva backgroundColor={props.backgroundColor} flowerdata={flowerdata} />
            </div>
        </div>
    );
};

function Drawings(props) {
    const { flowerdata } = props
    return <div className='Gbdrawings_root'>
        {flowerdata && flowerdata.length > 0 ? <Drawalldoodles backgroundColor={props.backgroundColor} flowerdata={flowerdata} /> : null}
    </div>

}

export default Drawings